import * as signalR from "@microsoft/signalr";

let connection = null;

/**
 * Initializes the SignalR connection.
 */
export const connectToHub = async (token) => {
  if (!connection) {
    connection = new signalR.HubConnectionBuilder()
      .withUrl(`${process.env.REACT_APP_BASE_URL}/hubs/notification`, {
        // .withUrl(`https://api.planetj.bet/hubs/notification`, {
        accessTokenFactory: () => token,
        withCredentials: true,
        // transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .build();
    // connection.onclose(async () => {
    //   console.warn("SignalR connection lost. Attempting to reconnect...");
    //   setTimeout(async () => {
    //     try {
    //       await connection.start();
    //       console.log("Reconnected to SignalR:", connection.connectionId);
    //     } catch (error) {
    //       console.error("Reconnection failed:", error);
    //     }
    //   }, 5000); // Delay before retrying to avoid spamming reconnections
    // });
    try {
      await connection.start();
      return connection;
    } catch (error) {
      console.error("SignalR connection failed:", error);
      throw error;
    }
  }

  return connection;
};

/**
 * Disconnects the SignalR connection.
 */
export const disconnectSignalR = async () => {
  if (connection) {
    await connection.stop();
    connection = null;
  }
};

/**
 * Invokes a method on the SignalR hub.
 */
export const invokeHubMethod = async (methodName, ...args) => {
  if (connection) {
    try {
      await connection.invoke(methodName, ...args);
    } catch (error) {
      console.error(`Error invoking hub method "${methodName}":`, error);
    }
  } else {
    console.error("SignalR connection is not established.");
  }
};
